import axios from "axios";
import { store } from "../redux/store";
import { logout } from "../redux/reducers/userSlice";
import { def } from "../config";

process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";

export default async function fetchServer({
  method,
  url,
  data,
  headers = {},
  cancelToken,
  api = def.api,
  onDownloadProgress,
}) {
  // console.log('api: ',api,process.env.REACT_APP_API)

  const requestHeaders = { ...headers };

  try {
    const token = store.getState().user.userData.accessToken;
    if (token) {
      requestHeaders.Authorization = "Bearer " + token;
    }
  } catch (ex) {}

  const isFormData =
    typeof FormData !== "undefined" && data instanceof FormData;

  const res = await axios({
    method,
    url: api + url,
    data,
    onDownloadProgress,
    headers: requestHeaders,
    cancelToken,
    ...(isFormData ? { transformRequest: [(body) => body] } : {}),
  }).catch((err) => {
    if (axios.isCancel(err)) {
      return { cancelled: true };
    }
    if (err?.response?.status === 401) {
      store.dispatch(logout());
    }
    if (!err?.response?.status)
      throw new Error(
        err || "Network Error! Please check your network connectivity."
      );

    return err?.response?.data;
  });

  return res;
}

axios.interceptors.request.use((config) => {
  config.metadata = { startTime: new Date() }; // Store the request start time
  return config;
});

axios.interceptors.response.use((response) => {
  const { startTime } = response.config.metadata;
  const elapsedTime = new Date() - startTime; // Calculate the elapsed time
  // const progress = Math.round((elapsedTime / 1000) * 10); // Assuming 10 milliseconds per percentage point
  // response.config.metadata.progress = progress;
  response.duration = elapsedTime;

  return response;
});
